// LIFTED (shim) for bagel-dashboard/src/utils/SourceIcon.tsx.
// Delegates to bagel-admin's native `getIntegrationMeta` (Tabler + lifted brand icons)
// instead of the dashboard's own icon registry, per the plan's locked decision.
import { getIntegrationMeta } from '../../integration-meta';

interface SourceIconProps {
  sourceName?: string;
  width?: number | string;
  height?: number | string;
  size?: number | string;
}

export function SourceIcon({ sourceName, width, height, size }: SourceIconProps) {
  const { icon: Icon } = getIntegrationMeta(sourceName);
  const resolved = size ?? width ?? height ?? 24;
  return <Icon size={resolved} />;
}

export default SourceIcon;
